<!-- <a routerLink="password/forgot">Forgot Password?</a>
<button  (click)="signInWithGoogle()">sign in with google</button>
<button  (click)="signInWithFB()">sign in with fb</button>
<button  (click)="refreshGoogleToken()">Refresh google token</button> -->

<!-- <div class="container">
    <div class="row">
        <div class="container" style="background-color: white;">
            <form [formGroup]="loginForm">
                <h2 class="text-center">Sign In to Biztory</h2>
                <p>Email</p>
                <input type="text" placeholder="User ID or email" formControlName="username" class="form-control"><br>
                <div *ngIf="login.username.touched && login.username.errors" class="invalid-feedback">
                    Invalid Email
                </div>
                <p>Password</p>
                <input type="password" placeholder="Password" class="form-control"><br>
                <div>Uh oh! Seems like the email or password is wrong</div>
                <input class="btn btn-lg btn-block btn-primary" type="submit" value="Sign in"><br>
                <a class="text-primary" routerLink="password/forgot">Forgot Password?</a><br>
                <button class="btn btn-lg btn-block" style="background-color:#7B68EE"><img src="#"> Sign in with Facebook</button><br>
                <button class="btn btn-lg btn-block" style="background-color:white;color:black"><img src="#"> Sign in with Google</button><br>
            </form>
        </div>
        <div class="col-lg-6 col-md-6 hidden-sm hidden-xs">
            <img src="#" class="img-reponsive">
        </div>
    </div>
</div> -->

<!-- <div class="formContainer">
    <div class="card">
        <div class="card-body">
            <div class="loginHeader">
                <h2>Sign In to Biztory</h2>
            </div>
            <form [formGroup]="loginForm">
                <div class="form-group col">
                    <label>Email</label>
                    <input type="email" class="form-control" placeholder="User ID or Email">
                </div>
                <div class="form-group col">
                    <label>Password</label>
                    <input type="password" class="form-control" placeholder="Password">
                </div>
                <div class="form-group col">
                    <button type="submit" class="btn btn-primary btn-block" (click)="onSubmit()">Sign In</button>
                </div>
                <div class="form-group col">
                    <a routerLink="password/forgot">Forgot Password?</a>
                </div>
                <div class="form-group col">
                    <button type="button" class="btn btn-info btn-block">Sign In with Facebook</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="bannerContainer">
    <img src="https://cdn.biztoryapp.com/beta/img/ads/en/cny.jpg">
</div> -->

<div class="formContainer">
	<div class="loginCard">
		<p>
			{{ 'register.no-acc' | translate
			}}<a class="biztory-link" routerLink="/register">{{ 'register.signup' | translate }}</a>
		</p>
		<div class="card">
			<div class="card-body">
				<div class="loginHeader">
					<h2>{{ 'register.signIn' | translate }}</h2>
				</div>
				<form [formGroup]="loginForm">
					<div class="form-group col">
						<label>{{ 'register.biztoryId' | translate }}</label>
						<input
							type="email"
							class="form-control"
							formControlName="username"
							placeholder="{{ 'register.biztoryId' | translate }}"
							[ngClass]="{ 'input-error': login.username.touched && login.username.errors }"
						/>
						<div *ngIf="login.username.touched && login.username.errors" class="invalid-feedback">
							<div *ngIf="login.username.errors.required">{{ 'register.biztoryId_req' | translate }}</div>
							<div *ngIf="login.username.errors.email">{{ 'register.biztoryId_valid' | translate }}</div>
						</div>
					</div>
					<div class="form-group col">
						<label>{{ 'register.password' | translate }}</label>
						<input
							type="password"
							class="form-control"
							formControlName="password"
							placeholder="{{ 'register.password' | translate }}"
							[ngClass]="{ 'input-error': login.password.touched && login.password.errors }"
						/>
						<div *ngIf="apiError" class="invalid-feedback">{{ apiError }}</div>
						<div *ngIf="login.password.touched && login.password.errors" class="invalid-feedback">
							<div *ngIf="login.password.errors.required">{{ 'register.password_req' | translate }}</div>
						</div>
					</div>
					<div class="form-group col">
						<button
							type="submit"
							class="btn btn-primary btn-block"
							(click)="onLogin()"
							[disabled]="isLoading$ | async"
							[class.spinner]="isLoading$ | async"
							[disabled]="loginForm.touched && loginForm.invalid"
						>
							{{ 'register.signinButton' | translate }}
						</button>
					</div>
					<div class="form-group col">
						<a routerLink="/password/forgot">{{ 'register.forgot' | translate }}</a>
					</div>
					<div class="col web-view">
						<!-- <button type="button" (click)="signInWithGoogle()" class="btn btn-info btn-block google-login-button">
							<img
								class="logo-img"
								src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-512.png"
							/>{{ 'register.signinGG' | translate }}
						</button> -->
						<div class="my-2">
							<asl-google-signin-button class="my-2" type="standard" size="large" width="318"></asl-google-signin-button>
						</div>
						<button type="button" (click)="signInWithFB()" class="btn btn-info fb-button my-2 d-flex align-items-center">
							<mat-icon class="col-2" svgIcon="facebook"></mat-icon>
							<span class="col-10">{{ 'register.signinFB' | translate }}</span>
						</button>
						<!-- <button width="318px" type="button" (click)="signInWithFB()" class="btn btn-info my-2">
							<img
								class="img-responsive"
								src="https://cdn1.iconfinder.com/data/icons/logotypes/32/square-facebook-512.png"
							/>{{ 'register.signinFB' | translate }}
						</button> -->
					</div>
					<div class="mobile-view col">
						<div class="m-1">
							<asl-google-signin-button type="icon" size="large"></asl-google-signin-button>
						</div>

						<div class="m-1">
							<button type="button" class="btn btn-info fb-button fb-button-sm" (click)="signInWithFB()">
								<img
									height="20px"
									width="20px"
									class="img-responsive"
									src="https://cdn1.iconfinder.com/data/icons/social-networks-15/512/facebook_network_logo-512.png"
								/>
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="loginBanner">
		<a href="{{ 'login.' + image + '_link' | translate }}" target="_blank"
			><img
				src="assets/image/ads/{{ translate.currentLang }}/{{ 'login.' + image | translate }}"
				class="img-responsive"
		/></a>
	</div>
	<footer class="login-footer">
		<div class="footer-content">
			<div class="footer-logos" [ngClass]="{ 'vertical-mobile': isMobile && footerLogos.length > 4 }">
				<span class="footer-label">Recognized by:</span>
				<img *ngFor="let logo of footerLogos" [src]="logo.src" [alt]="logo.alt" class="footer-logo" />
			</div>
		</div>
	</footer>
</div>
